import { OrdersDiscountAmounts_GroupedDiscountAmount } from "@springtree/eva-services-core";
import { PrefigureDiscountsResponse } from "@springtree/eva-services-core/lib/eva-services-core";

import { useCart } from "~/hooks/use-cart";
import intlUtils from "~/utils/intl-utils";

import styles from "../../products/discount-lines-totals.module.scss";

type Props = {
  lines: OrdersDiscountAmounts_GroupedDiscountAmount[];
  prefiguredDiscounts: PrefigureDiscountsResponse;
  orderId: string;
  currency: string;
};

export default function GuestTrackYourOrderDiscountLinesTotals(props: Props) {
  const priceFormatter = intlUtils.usePriceFormatter();
  const currency = props.currency;
  const cart = useCart();

  const discountLines = props.lines.map((discount) => {
    const prefigureDiscountResult = props.orderId
      ? props.prefiguredDiscounts?.Results
      : cart?.AdditionalOrderData?.PrefiguredDiscounts;

    const promoLabelLocalized =
      prefigureDiscountResult && prefigureDiscountResult.length > 0
        ? prefigureDiscountResult.find((prefiguredDiscount) => prefiguredDiscount.DiscountID === discount.DiscountID)
            ?.MarketingDescription
        : undefined;

    return {
      discount: discount,
      description: promoLabelLocalized || discount.Discount?.Description,
    };
  });

  return (
    <>
      {discountLines.map((line) => (
        <div key={line.discount.DiscountID} className={styles.row}>
          <p className={styles.rowTitle}>{line.description}</p>
          <p className={styles.rowValue}>{priceFormatter.currency(line.discount.Total, { currency })}</p>
        </div>
      ))}
    </>
  );
}
